import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ActivePaymentGateways from '@/components/v2/ActivePaymentGateways';
import TheDiyActions from '@/components/v2/diy/TheDiyActions.vue';
import DiyMixin from '@/helpers/vue_mixins/v2/DiyMixin';
import PaymentOptionCard from '@/components/v2/PaymentOptionCard';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import SegmentAnalyticsMixin from '@/helpers/vue_mixins/v2/SegmentAnalyticsMixin';
let PaymentGateway = class PaymentGateway extends Mixins(DiyMixin, ViewportSizeMixin, SegmentAnalyticsMixin) {
};
__decorate([
    Prop({ type: String, required: true })
], PaymentGateway.prototype, "appUuid", void 0);
PaymentGateway = __decorate([
    Component({
        components: {
            ActivePaymentGateways,
            TheDiyActions,
            PaymentOptionCard,
        },
    })
], PaymentGateway);
export default PaymentGateway;
